var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsersIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.087,
    viewBox: "0 0 20 20.087",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "UsersIcon",
    d: "M3,21V19a4,4,0,0,1,4-4h4a4,4,0,0,1,4,4v2M16,3.13a4,4,0,0,1,0,7.75M21,21V19a4,4,0,0,0-3-3.85M5,7A4,4,0,1,0,6.172,4.172,4,4,0,0,0,5,7Z",
    transform: "translate(-2 -1.913)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIconDark);
export default __webpack_public_path__ + "static/media/UsersIconDark.e873f802366d434a4254911b8e0bdcde.svg";
export { ForwardRef as ReactComponent };